<template>
    <div class="table-responsive">
        <div v-if="!invoices" class="col-12">{{ $t('loading') }}</div>
        <table class="table table--card table-hover" v-else-if="invoices && invoices.length > 0">
            <thead>
            <tr>
                <th style="width:40px;">
                    <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" />
                </th>
                <th>{{ $t('invoice_number') }}</th>
                <th>{{ $t('client') }}</th>
                <th>{{ $t('issued_at') }}</th>
                <th>{{ $t('total') }}</th>
                <th class="text-right">{{ $t('status') }}</th>
            </tr>
            </thead>
            <tbody v-if="invoices">
            <tr v-for="invoice in invoices"
                :key="invoice.id">
                <td @click.stop>
                    <input type="checkbox"
                           :value="invoice.id"
                           v-model="selectedIds"
                           @change="emitSelection" />
                </td>
                <td class="pointer" @click="openInvoice(invoice)">{{ invoice.number }}</td>
                <td class="pointer" @click="openInvoice(invoice)">{{ invoice.client ? invoice.client.company_name : '' }}</td>
                <td class="pointer" @click="openInvoice(invoice)">{{ invoice.issued_at | date('D MMM YYYY', 'YYYY-MM-DD') }}</td>
                <td class="pointer" @click="openInvoice(invoice)">
                    {{ invoice.subTotal | currency }}
                    <small v-if="invoice.taxTotal"><br>({{ invoice.total | currency }})</small>
                </td>
                <td class="text-right text-capitalize pointer" @click="openInvoice(invoice)">
                    <i class="material-icons material-icons-round md-18 mr-2 text-warning"
                       v-if="isOverDue(invoice)"
                       v-b-tooltip.hover title="Overdue">warning</i>
                    <i class="material-icons material-icons-round md-18 mr-2 text-success"
                       v-else-if="invoice.status === 'paid'">done</i>
                    {{ $t(`statuses.${invoice.status}`) }}
                </td>
            </tr>
            </tbody>
        </table>
        <EmptyState v-else/>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { formatDate } from '@/filters/date.filter';
import EmptyState from '@/components/EmptyState';
import { formatCurrency } from '@/filters/currency.filter';
import Folder from '@/store/models/folder';
import dayjs from 'dayjs';
import { VBTooltip } from 'bootstrap-vue';

export default {
  i18nOptions: { namespaces: ['invoices-list', 'statuses'] },
  components: {
    EmptyState,
  },
  filters: {
    date: formatDate,
    currency: formatCurrency,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    activeFolderId: { type: String, default: null },
  },
  data() {
    return {
      selectedIds: [],
    };
  },
  computed: {
    ...mapGetters({
      allInvoices: 'invoices/all',
    }),
    invoices() {
      if (!this.activeFolderId) {
        return this.allInvoices;
      }
      const folderIds = this.getFolderAndDescendantIds(this.activeFolderId);
      return this.allInvoices.filter((inv) => {
        if (!inv.folder_ids || !Array.isArray(inv.folder_ids)) return false;
        return inv.folder_ids.some((fid) => folderIds.includes(fid));
      });
    },
    selectAll: {
      get() {
        return this.invoices.length > 0 && this.selectedIds.length === this.invoices.length;
      },
      set() {},
    },
  },
  watch: {
    activeFolderId() {
      this.selectedIds = [];
      this.emitSelection();
    },
  },
  mounted() {
    this.$store.dispatch('invoices/getInvoices');
  },
  methods: {
    openInvoice(invoice) {
      this.$store.commit('invoices/invoiceId', invoice.id);
      this.$router.push({
        name: 'invoice',
        params: { id: invoice.id },
      }).catch(() => {});
    },
    isOverDue(invoice) {
      return invoice.status === 'sent' && invoice.due_at < dayjs().format();
    },
    getFolderAndDescendantIds(folderId) {
      const ids = [folderId];
      const addChildIds = (parentId) => {
        Folder.query().where('parent_id', parentId).get().forEach((child) => {
          ids.push(child.id);
          addChildIds(child.id);
        });
      };
      addChildIds(folderId);
      return ids;
    },
    toggleSelectAll() {
      if (this.selectedIds.length === this.invoices.length) {
        this.selectedIds = [];
      } else {
        this.selectedIds = this.invoices.map(inv => inv.id);
      }
      this.emitSelection();
    },
    emitSelection() {
      this.$emit('selection-change', this.selectedIds);
    },
  },
};
</script>
